import script from "./confirm-gift-card-redemption.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-gift-card-redemption.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__